/*
 * 功能模块的颜色变量配置
 */

import { ThemeColors } from '..';

export const libraryColors: ThemeColors = {
  color: {
    'library-upgrade-storage-tip': 'var(--library-upgrade-storage-tip)',
    'library-upgrade-storage-tip-danger': 'var(--library-upgrade-storage-tip-danger)',
    'library-upgrade-tip': 'var(--library-upgrade-tip)',
  },
  backgroundColor: {
    'library-upgrade-tip-bg': 'var(--library-upgrade-tip-bg)',
    'library-upgrade-storage-bg': 'var(--library-upgrade-storage-bg)',
  },
  borderColor: {},
};
